export const WAREHOUSE_SYNC_JOB_STATUS_VALUES = {
  pending: 'pending',
  deleting: 'deleting',
  syncing: 'syncing',
  cleaning: 'cleaning',
  validating: 'validating',
  rebuilding: 'rebuilding',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type WarehouseSyncJobStatus =
  (typeof WAREHOUSE_SYNC_JOB_STATUS_VALUES)[keyof typeof WAREHOUSE_SYNC_JOB_STATUS_VALUES];

export const WAREHOUSE_SYNC_JOB_STATUS_LABELS: Record<WarehouseSyncJobStatus, string> = {
  pending: 'Pending',
  deleting: 'Deleting',
  syncing: 'Syncing',
  cleaning: 'Cleaning Up',
  validating: 'Validating',
  rebuilding: 'Rebuilding',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
};
